import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { IntegrationEntitySyncTag } from "components";
import { ITableV2Column } from "components/table-v2/table-v2";
import { DefaultHeaderCell } from "components/table-v2/header-cells";
import { DefaultRowCell } from "components/table-v2/row-cells";
import { TReapitSyncLeadSourceExtendedData } from "types/reapit.type";
import { ReapitLeadSourceSyncSelect } from "./ReapitLeadSourceSyncSelect";

export const syncReapitLeadSourceTableColumnDef = (
  accountStore: UserAccountStore,
  updateSyncPair: (syncPair: TReapitSyncLeadSourceExtendedData) => void
): ITableV2Column<TReapitSyncLeadSourceExtendedData>[] => {
  return [
    {
      accessor: "leadSourceName",
      Header: <DefaultHeaderCell>LeadPro source</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell textTransform={"capitalize"}>
          {row.leadSourceName}
        </DefaultRowCell>
      ),
    },
    {
      accessor: "reapitId",
      excludeFromGlobalFilter: true,
      disableSortBy: true,
      Header: <DefaultHeaderCell>Reapit source</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <ReapitLeadSourceSyncSelect
            accountStore={accountStore}
            onChange={updateSyncPair}
            record={row}
          />
        </DefaultRowCell>
      ),
    },
    {
      accessor: "syncStatus",
      excludeFromGlobalFilter: true,
      Header: <DefaultHeaderCell>Status</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <IntegrationEntitySyncTag syncStatus={row.syncStatus} />
        </DefaultRowCell>
      ),
    },
  ];
};
